import React from 'react'
// import {Link} from 'react-router-dom'
import '../styles/NavBar.scss'
import {Navbar, Nav} from 'react-bootstrap'
import PropTypes from 'prop-types'
import RightNav from './RightNav'

const NavBar = ({admin}) => {

  return (
    <Navbar collapseOnSelect expand="md" bg="dark" variant="dark" sticky="top">
      <Navbar.Brand >
        <img
          src={require('../sb_icon.png')?.default}
          width="45"
          height="45"
          className="d-inline-block"
          alt="Powered by ScienceBase"
        /> ScienceBase File Manager
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
        </Nav>
        <RightNav admin={admin}/>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavBar
NavBar.propTypes = {
  admin: PropTypes.bool
}
